<template>
	<div id="GeneratedSubscriptions" class="generatedSubscriptions">
		<vue-snotify></vue-snotify>
        <nav class="navbar navbar-light bg-light">
            <div class="form-inline">
                <input class="form-control form-control-sm mr-sm-1" type="date" v-model="fromDateGenesys">
                <input class="form-control form-control-sm mr-sm-1" type="date" v-model="toDateGenesys">
                <input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Buscar" aria-label="Buscar" v-model="searchMovimiento" v-on:keyup.enter="searchSuscripcion">
                <button class="btn btn-sm btn-outline-success my-2 my-sm-0" type="button" @click="searchSuscripcion">Buscar</button>
                <div class="float-right d-none d-sm-inline separator"></div>
                <span class="margin-rigth-5">{{ listEnvioSuscripcionFilter.length }} / {{ listEnvioSuscripcion.length }}</span>
            </div>
            <div class="form-inline">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="viewOnlyWarning" v-model="viewOnlyWarning">
                    <label class="form-check-label" for="viewOnlyWarning">Solo Extraños</label>
                </div>
                <div class="float-right d-none d-sm-inline separator"></div>
                <i class="fas fa-cog pointer" data-toggle="modal" data-target="#modalSetingModule" ref="openModalSetingModule"></i>
            </div>
        </nav>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th>
						<div class="dropdown">
							<button class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<b>Campo</b>
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
								<span class="dropdown-item pointer" v-for="(item, index) in listCampo" :key="index"  @click="campoSelected = item.campomisdesc">
									<div class="form-group form-check">
										<span class="form-check-label" for="exampleCheck1">{{ item.campomisdesc }}</span>
                                        <i class="fas fa-check float-right" v-if="campoSelected == item.campomisdesc"></i>
									</div>
								</span>
							</div>
						</div>
                    </th>
                    <th>Cliente</th>
                    <th>CPIL</th>
                    <th>Dirección</th>
                    <th>Telefono</th>
                    <th>
                        <span  v-if="1 == 1">Trasnporte</span>
						<div class="dropdown" v-else>
							<button class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<b>Trasnporte</b>
							</button>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
								<span class="dropdown-item pointer" v-for="(item, index) in listTransporte" :key="index"  @click="transporteSelected = item.trandesc">
									<div class="form-group form-check">
										<span class="form-check-label" for="exampleCheck1">{{ item.trandesc }}</span>
                                        <i class="fas fa-check float-right" v-if="transporteSelected == item.trandesc"></i>
									</div>
								</span>
							</div>
						</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in listEnvioSuscripcionFilter" :key="index" v-show="!viewOnlyWarning || (viewOnlyWarning && (index > 0 && listEnvioSuscripcionFilter[index-1].clicodcli == item.clicodcli) || (index < listEnvioSuscripcionFilter.length-1 && listEnvioSuscripcionFilter[index+1].clicodcli == item.clicodcli))">
                    <td :title="item.campomiscod">{{ item.campomisdesc }}</td>
                    <td :title="item.clicodcli">{{ item.cliente }}</td>
                    <td :title="item.clicodcpil">{{ item.cpil }}</td>
                    <td :title="item.domicod">{{ item.direccion + ' (' + item.dptodesc + ')' }}</td>
                    <td>{{ item.domitel }}</td>
                    <td>
                        <span :class="'badge badge-' + getColorTransport(searchIdTransportsByStr(item.trandesc))">
                            {{ item.trandesc }}
						</span>
                    <td>
                        <i v-if="(index > 0 && listEnvioSuscripcionFilter[index-1].clicodcli == item.clicodcli) || (index < listEnvioSuscripcionFilter.length-1 && listEnvioSuscripcionFilter[index+1].clicodcli == item.clicodcli)"
                            class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                        <i class="fa fa-eye pointer text-info" aria-hidden="true" @click="searchSuscripcionByValues(item)"></i>
                        <i class="fas fa-print pointer" aria-hidden="true" @click="setSuscripcionImpresionEtiquetaByValues(item)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="modal fade" id="showModalListEnvioSuscripcionDetail" tabindex="-1" aria-labelledby="showModalListEnvioSuscripcionDetail" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="showModalListEnvioSuscripcionDetail">Movimientos {{ itemSelectListEnvioSuscripcion.cliente }} ({{ itemSelectListEnvioSuscripcion.campomisdesc}})</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="form-group row">
                                <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Enviar a:</label>
                                <div class="col-sm-10">
                                    <select v-model="itemSelectListEnvioSuscripcion.clicodcpil" class="form-control form-control-sm" @change="getDomicilioIdCliente(itemSelectListEnvioSuscripcion.clicodcpil)" ref="cpil">
                                        <option v-for="(item, index) in listVinculoCli" :key="index" :value="item.vinclicod" v-if="item.vigente == '1' && item.tipovincod == '1'">{{ item.vincliente }}</option>
                                    </select>
                                    <small id="emailHelp" class="form-text text-muted">{{ itemSelectListEnvioSuscripcion.cpil }}</small>
                                </div>
                            </div>									
                            <div class="form-group row">
                                <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Direccion:</label>
                                <div class="col-sm-10">
                                    <select v-model="itemSelectListEnvioSuscripcion.domicod" class="form-control form-control-sm" @change="setValueComuna()" ref="domicalle">
                                        <option v-for="(item, index) in listDomicilioCliente" :key="index" :value="item.domicod">{{ item.domicalle }}</option>
                                    </select>
                                    <small id="emailHelp" class="form-text text-muted">{{ itemSelectListEnvioSuscripcion.direccion }}</small>
                                </div>
                            </div>									
                            <div class="form-group row">
                                <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Comuna:</label>
                                <div class="col-sm-4">
                                    <input type="comuna" class="form-control form-control-sm" id="colFormLabelSm" placeholder="Comuna" v-model="itemSelectListEnvioSuscripcion.dptodesc" disabled="true">
                                </div>
                                <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Telefono:</label>
                                <div class="col-sm-4">
                                    <input type="telefono" class="form-control form-control-sm" id="colFormLabelSm" placeholder="Telefono"
                                        v-model="itemSelectListEnvioSuscripcion.domitel"
                                        @blur="itemSelectListEnvioSuscripcion.setDomitel = 'false'; itemSelectListEnvioSuscripcion.domitel = itemSelectListEnvioSuscripcion.domitel_back"
                                        @keyup.enter="changeDomitel()"
                                        @focus="itemSelectListEnvioSuscripcion.domitel_back = itemSelectListEnvioSuscripcion.domitel">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Transporte:</label>
                                <div class="col-sm-4">
                                    <input type="transporte" class="form-control form-control-sm" id="colFormLabelSm" placeholder="Transporte"
                                        v-model="itemSelectListEnvioSuscripcion.trandesc"
                                        @blur="itemSelectListEnvioSuscripcion.setTrandesc = 'false'; itemSelectListEnvioSuscripcion.trandesc = itemSelectListEnvioSuscripcion.trandesc_back"
                                        @keyup.enter="changeTrandesc()"
                                        @focus="itemSelectListEnvioSuscripcion.trandesc_back = itemSelectListEnvioSuscripcion.trandesc">
                                </div>
                            </div>
                        </div>
                        <table class="table table-sm">
                            <thead>
                                <tr class="text-center">
                                    <th>Comprobante</th>
                                    <th>Nro Comp</th>
                                    <th>Fecha</th>
                                    <th>Usuario</th>
                                    <th>Lote</th>
                                </tr>
                            <thead>
                            </thead>
                                <tr v-for="(item, index) in listMovimientosEnvios" :key="index">
                                    <td>{{ item.tipocompdesc }}</td>
                                    <td class="text-right">{{ item.nrocomp }}</td>
                                    <td class="text-center">{{ item.feccomp }}</td>
                                    <td>{{ item.usuario }}</td>
                                    <td class="text-center">{{ item.lote }}</td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-info" @click="setSuscripcionImpresionEtiquetaByValues(itemSelectListEnvioSuscripcion)">Imprimir Etiqueta</button>
                        <button type="button" v-show="false" data-toggle="modal" data-target="#showModalListEnvioSuscripcionDetail" ref="showModalListEnvioSuscripcionDetail">Launch demo modal</button>
                        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

		<!-- Modal -->
		<div class="modal fade" id="modalSetingModule" tabindex="-1" aria-labelledby="modalSetingModuleLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="modalSetingModuleLabel">Configuraciones del Modulo</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				<div class="modal-body">
					<div class="form-group row">
						<label for="printerWebSocketServer" class="col-sm-3 col-form-label">Impresora de Etiqueta</label>
						<div class="col-sm-6">
							<select class="form-control form-control-sm" id="printerWebSocketServer" :disabled="!successFullConnectionWebSocketServer" v-model="indexSelectedPrinterWebSocketServer" @change="changeSelectedPrinterWebSocketServer">
								<option v-for="(item, index) in listPrinterWebSocketServer" :value="index" :key="index">{{ item }}</option>
							</select>
						</div>
						<div class="col-sm-2">
      						<button class="btn btn-primary btn-sm" @click="toPrintWithVariables" :disabled="!successFullConnectionWebSocketServer">Imprimir</button>
    					</div>
					</div>
					<div class="form-group row">
						<label for="printerFacturacionCLPrint" class="col-sm-3 col-form-label">Impresora de Boletas</label>
						<div class="col-sm-6">
							<select class="form-control form-control-sm" id="printerFacturacionCLPrint" :disabled="!successFullConnectionFacturacionCLPrint" v-model="indexSelectedPrinterFacturacionCLPrint" @change="changeSelectedPrinterFacturacionCLPrint">
								<option v-for="(item, index) in listPrinterFacturacionCLPrint" :value="index" :key="index">{{ item }}</option>
							</select>
						</div>
						<div class="col-sm-2">
      						<button class="btn btn-primary btn-sm" @click="toPrintFacturacionCL(39, 1)" :disabled="!successFullConnectionFacturacionCLPrint">Imprimir</button>
    					</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import genesys from '@/mixins/genesys'
import suscripcion from '@/mixins/genesys/suscripcion.js'
import cliente from '@/mixins/genesys/cliente.js'
import domicilio from '@/mixins/genesys/domicilio.js'
import transport from '@/mixins/transports'
import label from "@/mixins/labels/"
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import webSocketServer from '@/mixins/webSocketServer.js'


export default {
	name: 'GeneratedSubscriptions',
	mixins: [axiosAction, errors, mixin, genesys, suscripcion, cliente, domicilio, transport, label, facturacionCLPrint, webSocketServer],
	data() {
		return {
			viewOnlyWarning: true,
            campoSelected: 'Todos',
            transporteSelected: 'Todos'
		}
	},
	computed: {
        listCampo() {
            let hash = [{'campomiscod': '0', 'campomisdesc': 'Todos'}]
            this.listEnvioSuscripcion.filter(
                item => {
                    let index = hash.map((el) => parseInt(el.campomiscod)).indexOf(parseInt(item.campomiscod))
                    if(index < 0) {
                        hash.push(item)
                        return true
                    } else {
                        return false
                    }
                });
            return hash
        },
        listEnvioSuscripcionFilter() {
            return this.listEnvioSuscripcion.filter(item => 
                (item.campomisdesc == this.campoSelected || this.campoSelected == 'Todos') &&
                (item.trandesc.trim() == this.transporteSelected || this.transporteSelected == 'Todos')
            )
        },
        listTransporte() {
            let hash = [{'trandesc': 'Todos'}]
            this.listEnvioSuscripcion.filter(
                item => {
                    let index = hash.map((el) => el.trandesc.trim()).indexOf(item.trandesc.trim())
                    if(index < 0) {
                        hash.push({'trandesc': item.trandesc.trim()})
                        return true
                    } else {
                        return false
                    }
                });
            return hash
        }
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Suscripciones Generadas')
			this.setSubTitleModule('')
			this.fromDateGenesys = this.currentDate(-30)
			this.toDateGenesys = this.currentDate()
            this.getAllTransports()
            this.showLabel(2)
		},
		changeDomitel() {
			if(this.itemSelectListEnvioSuscripcion.domitel != this.itemSelectListEnvioSuscripcion.domitel_back && this.itemSelectListEnvioSuscripcion.domitel.trim() != '') {
				this.setDomitel(this.itemSelectListEnvioSuscripcion.domicod, this.itemSelectListEnvioSuscripcion.domitel.trim())
			}
		},
		changeTrandesc() {
			let changeTrandescOriginal = '1'
			if(this.itemSelectListEnvioSuscripcion.trandesc != this.itemSelectListEnvioSuscripcion.trandesc_back && this.itemSelectListEnvioSuscripcion.trandesc.trim() != '') {
				this.setTrandesc(this.listMovimientosEnvios, this.itemSelectListEnvioSuscripcion.trandesc, changeTrandescOriginal)
			}
		},
		getEnvioSuscripcionByValuesResultLocal() {
			this.$refs.showModalListEnvioSuscripcionDetail.click()
			this.getVinculoCli(this.itemSelectListEnvioSuscripcion.clicodcli)
		},
		getVinculoCliResultLocal(response) {
			this.getDomicilioIdCliente(this.itemSelectListEnvioSuscripcion.clicodcpil)
		},
		getDomicilioIdClienteResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.domicod
			let index = this.listDomicilioCliente.map((el) => el.domicod).indexOf(this.itemSelectListEnvioSuscripcion.domicod)
			if(index < 0 && this.listDomicilioCliente.length > 0) {
				this.itemSelectListEnvioSuscripcion.domicod = this.listDomicilioCliente[0].domicod
				this.setValueComuna()
			}
		},
        resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getAllTransportsResult': this.getAllTransportsResult(responseLocal, response); break;
                case 'resultShowLabelGET': this.resultShowLabelGET(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
        },
        searchSuscripcionByValues(item) {
            this.listMovimientosEnvios = []
            this.itemSelectListEnvioSuscripcion = item
            this.getEnvioSuscripcionByValues('20,40', this.fromDateGenesys, this.toDateGenesys, item.clicodcli, item.clicodcpil, item.domicod, item.trandesc)
        },
		setValueComuna() {
			this.setDomicod(this.listMovimientosEnvios, this.itemSelectListEnvioSuscripcion.domicod, '1', this.itemSelectListEnvioSuscripcion.clicodcpil)
		},
		setDomicodResultLocal(response) {
			let index = this.listDomicilioCliente.map((el) => el.domicod).indexOf(this.itemSelectListEnvioSuscripcion.domicod)
			console.log(this.listDomicilioCliente[index])
			this.itemSelectListEnvioSuscripcion.dptodesc = this.listDomicilioCliente[index].dptodesc
			this.itemSelectListEnvioSuscripcion.domitel = this.listDomicilioCliente[index].domitel
			this.itemSelectListEnvioSuscripcion.direccion = this.listDomicilioCliente[index].domicalle

		},
		setDomitelResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.domitel_back = this.itemSelectListEnvioSuscripcion.domitel
        },
        setSuscripcionImpresionEtiquetaByValues(item) {
            this.itemSelectListEnvioSuscripcion = item
            let valstr = 'Suscripcion iSystem 4'
            this.setImpresionEtiquetaByValues('20,40', this.fromDateGenesys, this.toDateGenesys, item.clicodcli, item.clicodcpil, item.domicod, item.trandesc, valstr, 15)
        },
		setTrandescResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.trandesc_back = this.itemSelectListEnvioSuscripcion.trandesc
        },
        setImpresionEtiquetaByValuesResultLocal(response) {
            this.itemSelectListEnvioSuscripcion.codbareti = response.data.data
            this.toPrintLabel(this.itemSelectListEnvioSuscripcion)
        },
        toPrintLabel(item) {
			let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(this.searchIdTransportsByStr(this.itemSelectListEnvioSuscripcion.trandesc)))
			let arrayZPL = []
            arrayZPL.push({'name': 'sendto' , 'value': this.cleanedStringZPL(this.itemSelectListEnvioSuscripcion.cpil).toUpperCase()})
            arrayZPL.push({'name': 'address' , 'value': this.cleanedStringZPL(this.itemSelectListEnvioSuscripcion.direccion).toUpperCase()})
            arrayZPL.push({'name': 'comuna' , 'value': this.cleanedStringZPL(this.itemSelectListEnvioSuscripcion.dptodesc).toUpperCase()})
            arrayZPL.push({'name': 'phone' , 'value': this.cleanedStringZPL(this.itemSelectListEnvioSuscripcion.domitel).toUpperCase()})
            arrayZPL.push({'name': 'img_zpl' , 'value': (index > 0 && this.listTransports[index].img_zpl != null) ? this.listTransports[index].img_zpl : this.itemSelectListEnvioSuscripcion.trandesc})
            arrayZPL.push({'name': 'paid_shipping_desc' , 'value': 'CTACTE'})
			arrayZPL.push({'name': 'clicod' , 'value': 'IGL' + this.itemSelectListEnvioSuscripcion.clicodcli})
			arrayZPL.push({'name': 'cliente' , 'value': this.itemSelectListEnvioSuscripcion.cliente})
			arrayZPL.push({'name': 'codbareti' , 'value': 'ES' + this.itemSelectListEnvioSuscripcion.codbareti + '0001'})
			arrayZPL.push({'name': 'campomisdesc' , 'value': this.itemSelectListEnvioSuscripcion.campomisdesc })
			arrayZPL.push({'name': 'total_price' , 'value': this.itemSelectListEnvioSuscripcion.brutocomp })
			this.replaceZPLVariableFromArray(arrayZPL)
			this.toPrintWithVariables()
		},

	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>
